<template>
      <div>
        <div class="row">
            <div class="col-12">
                <page-header
                :page="page"
                @onReturn="() => $router.back()"
                :has-return="true"
                />
            </div>
         </div>
        <div class="row">
            <div class="col">
                <filter-manager
                :display-advanced="false"
                class="search-bar"
                items-container-class="flex-wrap"
                search-icon="fa fa-sync"
                search-text="Procesar"
                search-container-class="btn-process"
                v-model="model.search.filters"
                :filters="filterManagerConfig"
                @search="onHandlerSearch"
                ref="filterRef"
                />
            </div>
        </div>
      </div>
</template>
<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import TicketsAPI from '@/services/api/detickets.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Reporte Registro de Visitantes',
      routes: ['Informes', 'Reporte Registro de Visitantes'],
    },
    model: {
      search: {
        collections: {
          departament: [],
          dateFrom: [],
          dateTo: [],
        },
        filters: {
          departament: null,
          dateFrom: null,
          dateTo: null,
        },
      },
    },

  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'departament',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Departamento:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un Departamento.',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          disabled:true,
          options: this.model.search.collections.departament,
          value: this.model.search.filters.departament,
        },
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Seleccionar Fecha Desde',
          class: 'col-md-4',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Seleccionar Fecha Hasta',
          class: 'col-md-4',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const { data: dpto } = await TicketsAPI.getDepts();
      this.model.search.collections.departament = [...dpto];
      this.model.search.filters.departament = dpto[2];
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async process() {
      try {
      const { data } = await ReportServices.getReport('visitorRegistration', {
          deptId: this.model.search.filters.departament.id,
          dateFrom: this.model.search.filters.dateFrom,
          dateTo: this.model.search.filters.dateTo,
        });
      
      if(data)
      {
        DocumentServices.Download(data);
      }
      else
      {
        this.ShowToast('Error', 'No existen registros con estos criterios.', 'error');
      }

      } catch {
        this.ShowToast('Error', 'Error al intentar cargar el reporte', 'error');
      }
    },
  },
}
</script>